import { useParams } from 'react-router-dom';

import { OrganizationUsersPage } from '~/components/pages/OrganizationUsersPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const OrganizationUsersRoute: React.FC = () => {
  const { organizationId } = useParams();

  if (!organizationId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate organizationId={organizationId}>
      <OrganizationUsersPage organizationId={organizationId} />
    </DashboardTemplate>
  );
};
